const menuItems = [
  { key: 'home', path: '/' },
  { key: 'about', path: '/about' },
  { key: 'resource', path: '/blogs' },
  { key: 'impact', path: '/impact' },
  { key: 'contact', path: '/contact' },
  {
    key: 'takeAction',
    path: '#', // Use '#' or a placeholder path
    subMenu: [
      { key: 'individual', path: '/IndividualTakeAction' },
      { key: 'community', path: '/CommunityTakeAction' },
      { key: 'company', path: '/CompanyTakeAction' },
    ],
  },
];

export default menuItems;
